import AppFooterKeys from "./AppFooter/AppFooter.i18n";
import ContextVisualizer from "./ContextVisualizer/ContextVisualizer.i18n";
import MaintenanceMessageKeys from "./Maintenance/MaintenanceMessage.i18n";
import ManageAppSettingsKeys from "./ManageAppSettings/ManageAppSettings.i18n";
import MessageProviderI18nKeys from "./MessageProvider/MessageProvider.i18n";
import ServiceErrorMessageKeys from "./MessageProvider/ServiceErrorMessage.i18n";
import ErrorPageKeys from "./Page/ErrorPage/ErrorPage.i18n";
import PageMessageKeys from "./PageMessage/PageMessage.i18n";
import SkipToContentKeys from "./SkipToContent/SkipToContent.i18n";
import PlacementsUpdaterKeys from "./Toolbox/PlacementsUpdater.i18n";
import VersionKeys from "./Version/Version.i18n";

export default {
  ...AppFooterKeys,
  ...ContextVisualizer,
  ...ErrorPageKeys,
  ...MaintenanceMessageKeys,
  ...ManageAppSettingsKeys,
  ...MessageProviderI18nKeys,
  ...PageMessageKeys,
  ...ServiceErrorMessageKeys,
  ...SkipToContentKeys,
  ...PlacementsUpdaterKeys,
  ...VersionKeys,
};
